import { render, staticRenderFns } from "./ProductsTable.vue?vue&type=template&id=1c6ee991&scoped=true&"
import script from "./ProductsTable.vue?vue&type=script&lang=js&"
export * from "./ProductsTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductsTable.vue?vue&type=style&index=0&id=1c6ee991&lang=scss&scoped=true&"
import style1 from "./ProductsTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6ee991",
  null
  
)

export default component.exports